import { render } from "./VsSwitch.vue?vue&type=template&id=4f28156f"
import script from "./VsSwitch.vue?vue&type=script&lang=js"
export * from "./VsSwitch.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__